import BaseService from "../baseService";
class CentroCusto extends BaseService {
  constructor(id) {
    const resource = "nfe-ncm/centro-custo";
    let relationship = {};
    super(id, relationship, resource);
  }
}

export default (id) => new CentroCusto(id);
